/**
 *
 * Asynchronously loads the component for DefaultProductSettingsPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./DefaultProductSettingsPage"));
